module.exports = __webpack_public_path__ + "img/yunming-wang-1408276-unsplash.5a773484.jpg";